import { render } from "./Desktop.vue?vue&type=template&id=636fb1cc&scoped=true"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=636fb1cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-636fb1cc"

export default script